<template>

  <div class="row row-responsive">
    <div class="column column-xs-100 column-sm-100">
        <h4 class="title">Información general</h4>
        <div class="row row-responsive">
          <div class="column column-sm-33">
            <span class="title">Nombre</span>
            <p class="field">
              {{ generalInfo.name }} {{ generalInfo.middle_name }} {{ generalInfo.last_name }}
            </p>
            <span class="title">Nacionalidad</span>
            <p class="field">
              {{ generalInfo.nationality }}
            </p>
            <span class="title">CURP</span>
            <p class="field">
              {{ generalInfo.curp }}
            </p>
          </div>
          <div class="column column-sm-33">
            <span class="title">Fecha de nacimiento</span>
            <p class="field">
              {{ this.reverseBirthDate(generalInfo.birthdate)}}
            </p>
            <span class="title">Teléfono</span>
            <p class="field">
              {{ generalInfo.phone }}
            </p>
            <span class="title">RFC</span>
            <p class="field">
              {{ generalInfo.rfc }}
            </p>
          </div>
          <div class="column column-sm-33">
            <span class="title">País de nacimiento</span>
            <p class="field">
              {{ generalInfo.birthplace }}
            </p>
            <span class="title">Género</span>
            <p class="field">
              {{ generalInfo.gender }}
            </p>
            <span class="title">Estado civil</span>
            <p class="field">
              {{ civilState(generalInfo.married) }}
            </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import mixins from '@/mixins/index'

export default {
  name: 'UserProfileGeneralInfo',
  data () {
    return {
      generalInfo: [],
      addressInfo: null
    }
  },
  mixins: [mixins],
  methods: {
    civilState: function (bool) {
      let state

      if (bool === true) {
        state = 'Casado'
      } else if (bool === false) {
        state = 'Soltero'
      }

      return state
    }
  },
  created: function () {
    this.getUserData()
  }
}

</script>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileGeneralInfo.vue